<template>
  <div class="ws-state-datetime">
    <date-picker
      :value="_value"
      :format="format"
      :disabledDate="disabledDate"
      :disabledTime="disabledTime"
      type="datetime"
      @input="$emit('input',$moment($event))"
    ></date-picker>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    format: {
      type: String,
      default: "YYYY-MM-DD HH:mm:ss",
    },
    disabledDate: {
      type: Function,
    },
    disabledTime: {
      type: Function,
    },
    defaultValue: {},
  },
  computed: {
    _value() {
      return this.$moment(this.value).toDate();
    },
  },
  mounted(){
    this.$emit('input', this.$moment(this.defaultValue && !this.value ? this.defaultValue : this.value).toDate())
  }
};
</script>

<style lang="scss">
@import "../assets/scss/ws-state-datetime.scss";
</style>